module.exports = __webpack_public_path__ + "img/9788925554488.a303ebda.jpg";